import classNames from 'classnames';

import styles from './List.module.css';

export type ListProps = {
  hasColumns?: boolean;
  list: string[];
  mode?: 'light' | 'dark';
  name: string;
  resourcesUrl: string;
  testId?: string;
};

export const List = ({
  hasColumns,
  list,
  mode = 'light',
  name,
  resourcesUrl,
  testId
}: ListProps) => {
  const imageSrc = mode == 'light' ? 'list' : 'list-dark';

  return (
    <ul
      className={classNames(
        styles.list,
        hasColumns ? styles[`--columns`] : '',
        mode === 'dark' ? styles['--mode-dark'] : ''
      )}
      data-testid={testId}>

			{list.map((item, index) =>
      <li key={`${name}-item-${index}`}>
					<img
          alt=""
          src={`${resourcesUrl}/assets/img/subscribe/${imageSrc}.png`} />

					<span>{item}</span>
				</li>
      )}
		</ul>);

};